<script lang="ts">
	/**
	 * The hours object containing either a single value or a range of values.
	 * - If `value` is present, it represents a fixed number of hours.
	 * - If `minValue` and `maxValue` are present, they represent a range of hours.
	 * @type {{
	 *   value?: number;
	 *   minValue?: number;
	 *   maxValue?: number;
	 * }}
	 */
	export let hours: any = {};
</script>

{#if hours?.value}
	{hours?.value} uur
{:else}
	{hours?.minValue} - {hours?.maxValue} uur
{/if}
